import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import BoxKit from "@/shared/components/kit/box";
import CardKit from "@/shared/components/kit/card";
import { toPersianNumber } from "@/hooks/useThousandsSeparator";
/**
 * CustomerClub
 *
 * این کامپوننت یک نمای کامل از وضعیت باشگاه مشتریان ارائه می‌دهد. شامل سه بخش اصلی:
 * ۱. نمایش عنوان و آیکون باشگاه مشتریان.
 * ۲. نمایش سه دایره آماری شامل درصد مشتریان نقدی، اعتباری و آنلاین.
 * ۳. نمایش کارت‌های سطوح مشتریان (برنزی، نقره‌ای، طلایی) با اطلاعات تعداد و تصویر مربوطه.
 *
 * ویژگی‌ها:
 * - استفاده از BoxKit، StackKit، TypoGraphyKit و CardKit برای ساختاردهی و استایل‌دهی.
 * - کاملاً ریسپانسیو و سازگار با سایزهای مختلف صفحه.
 * - نمایش درصد مشتریان با تبدیل اعداد به فارسی.
 * - امکان اتصال اکشن برای کلیک روی هر سطح مشتری.
 *
 * @returns JSX.Element ساختار نمایشی باشگاه مشتریان شامل اطلاعات آماری و کارت‌های سطوح مشتریان
 */

const CustomerClub = () => {
  const handleAddBronze = () => { };

  const handleAddSilver = () => { };

  const handleAddGold = () => { };

  const cardsData = [
    {
      bg: "linear-gradient(38.92deg, #A16649 15.17%, #DC9166 46.88%, #FFEAC8 71.28%)",
      img: "/BronzeBrand.png",
      countText: "900 نفر",
      labelText: "مشتریان برنزی",
      onClick: handleAddBronze,
    },
    {
      bg: "linear-gradient(87.86deg, #888888 11.78%, #D0D0D0 53.34%, #F2F2F2 85.31%);",
      img: "/SilverBrand.png",
      countText: "1200 نفر",
      labelText: "مشتریان نقره‌ای",
      onClick: handleAddSilver,
    },
    {
      bg: "linear-gradient(38.92deg, #855B00 13.93%, #FFE3A6 49.1%, #FFC037 66.86%)",

      img: "/goldBrand.png",
      countText: "500 نفر",
      labelText: "مشتریان طلایی",
      onClick: handleAddGold,
    },
  ];

  const createCenterTextPlugin = (text: string) => ({
    id: "centerTextPlugin",
    beforeDraw: function (chart: any) {
      const { width, height, ctx } = chart;
      ctx.restore();
      ctx.font = "bold 18px vaziriFont, Arial";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "#333";

      const textX = Math.round((width - ctx.measureText(text).width) / 2);
      const textY = height / 2;

      ctx.fillText(text, textX, textY);
      ctx.save();
    },
  });
  return (
    <>
      <StackKit sx={{ width: "100%",padding:"1rem" }}>
        <StackKit direction={"row"} justifyContent={"start"} sx={{ padding: "15px 10px" }} gap={2}>
          <PeopleAltOutlinedIcon />
          <TypoGraphyKit variant="body1"> باشگاه مشتریان</TypoGraphyKit>
        </StackKit>
        <StackKit sx={{ width: "100%" }} justifyContent="center" alignItems="center">
          <BoxKit sx={{display: "grid",gridTemplateColumns: "repeat(1, auto)",gridTemplateRows: "auto auto",gap: 2,justifyItems: "center",alignItems: "center",}}>
            <BoxKit sx={{gridColumn: "1 / span 2",width: 72,height: 72,display: "flex",justifyContent: "center",alignItems: "center",flexDirection: "column",bgcolor: "#EB6440",borderRadius: "50%",position: "relative",right: "-50px",padding: "15px"}}>
              <TypoGraphyKit variant="h6" sx={{ color: "#000", fontSize: "10px" }}>
                {toPersianNumber(25)} %
              </TypoGraphyKit>
              <TypoGraphyKit variant="body1" sx={{ color: "#000", fontSize: "10px" }}>
                مشتریان اعتباری
              </TypoGraphyKit>
            </BoxKit>
            <BoxKit sx={{width: 54,height: 54,display: "flex",justifyContent: "center",alignItems: "center",flexDirection: "column",bgcolor: "#273B4A",borderRadius: "50%",padding: "15px"}}>
              <TypoGraphyKit variant="h6" sx={{ color: "#fff", fontSize: "8px" }}>
                {toPersianNumber(15)} %
              </TypoGraphyKit>
              <TypoGraphyKit variant="body1" sx={{ color: "#fff", fontSize: "8px" }}>
                مشتریان آنلاین
              </TypoGraphyKit>
            </BoxKit>
            <BoxKit sx={{width: 103,height: 103,display: "flex",justifyContent: "center",alignItems: "center",flexDirection: "column",bgcolor: "#7BC8B5",borderRadius: "50%",position: "relative",top: "-50px",padding: "15px"}}>
              <TypoGraphyKit variant="h6" sx={{ color: "#000" }}>
                {toPersianNumber(50)} %
              </TypoGraphyKit>
              <TypoGraphyKit variant="body1" sx={{ color: "#000" }}>
                مشتریان نقدی
              </TypoGraphyKit>
            </BoxKit>
          </BoxKit>
        </StackKit>


        <StackKit sx={{width: "100%",flexWrap: "wrap",justifyContent: "space-between",paddingInline: "10px",}} direction="row">
          {cardsData.map((card, index) => (
            <CardKit key={index} sx={{background: card.bg,position: "relative",width: {xs:"100%",sm:"100%", md: "100%", lg: "40%" },minWidth: "100px",margin: "2px !important",marginBottom: { md: "10px !important", lg: "0" },}}>
              <StackKit alignItems="start" spacing={1}>
                <TypoGraphyKit variant="body1" sx={{ color: "#000" }}>
                  {card.countText}
                </TypoGraphyKit>
                <BoxKit sx={{width: "25px",height: "41px",position: "absolute",top: "-10px",left: "5px",}}>
                  <img src={card.img} alt={card.labelText} />
                </BoxKit>
                <StackKit sx={{ width: "100%" }} justifyContent="center" alignItems="center">
                  <TypoGraphyKit variant="body1" sx={{ color: "#000" }}>
                    {card.labelText}
                  </TypoGraphyKit>
                </StackKit>
              </StackKit>
            </CardKit>
          ))}
        </StackKit>
      </StackKit>
    </>
  );
};

export default CustomerClub;
